import React, { useState } from 'react';
import PageHeader from 'src/Components/Customer/PageHeader';
import FavDoctors from 'src/Components/FavComponents/FavDoctors';
import FavTests from 'src/Components/FavComponents/FavTests';
import FavPackages from 'src/Components/FavComponents/FavPackages';
import FavPharma from 'src/Components/FavComponents/FavPharma';
import FavHomecare from 'src/Components/FavComponents/FavHomecare';

type tabTypes = "My Doctors" | "Tests" | "Packages" | "Pharma Products" | "At Home Service";
const MyLists: React.FC = () => {
    const tabList: tabTypes[] = ["My Doctors", "Tests", "Packages", "Pharma Products", "At Home Service"];
    const [activeTab, setActiveTab] = useState<tabTypes>("My Doctors");
    return (
        <>
            <PageHeader
                title="My Lists"
            />
            <div style={{ minHeight: `calc(${document.getElementById('customer-sidebar-id')?.offsetHeight}px - 1rem - ${document.getElementById('headerH')?.offsetHeight}px)` }} className="parent-box parent-box-height">
                <div className='flex justify-between items-center'>
                    <div className='products-tabs-btn'>
                        {tabList.map((v: tabTypes) => (
                            <button
                                disabled={activeTab === v}
                                key={v}
                                className={`font-size-14px font-Poppins-Medium rounded-pill ${activeTab === v && 'active'}`}
                                onClick={() => setActiveTab(v)}
                            >
                                {v}
                            </button>
                        ))}
                    </div>
                </div>
                {activeTab === "My Doctors" ?
                    <FavDoctors />
                    : activeTab === "Tests" ?
                        <FavTests />
                        : activeTab === "Packages" ?
                            <FavPackages />
                            : activeTab === "Pharma Products" ?
                                <FavPharma />
                                : activeTab === "At Home Service" ?
                                    <FavHomecare />
                                    : null
                }
            </div>
        </>
    );
};

export default MyLists;